import { useCallback, useState, useEffect } from 'react';
import _ from 'lodash';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { withRouter } from 'react-router-dom';
import { PolicyService } from 'gw-capability-policy';
import { useDependencies } from 'gw-portals-dependency-react';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { ModalNextProvider } from '@jutro/components';
import { error } from '@jutro/logger';
import {
    withApplicationPropertyContext
} from 'tdic-components-platform-react';
import { EmailUtil } from 'gw-portals-util-js';
import metadata from './UserEmailConfirmation.metadata.json5';
import styles from './UserEmailConfirmation.module.scss';
import messages from './UserEmailConfirmation.message';

function UserEmailConfirmation(props) {
    const {
        email, user_name: userName, authHeader, enrolledPolicy, history,
        tncTransactionTypesSubTypes, isAuthorisedUser
    } = props;
    const [formData, setFormData] = useState({
        email: EmailUtil.checkEmailValidity(email)
            ? email : userName
    });
    const [acceptCheckbox, setAcceptCheckbox] = useState(false);
    const { EndorsementService } = useDependencies('EndorsementService');
    const tncType = _.find(tncTransactionTypesSubTypes, { transaction_Type: 'Login' });
    const [isFormSubmitted, setFormSubmitted] = useState(false);
    const role = isAuthorisedUser ? 'AuthorisedUser' : 'PolicyHolder';
    const tncSubType = _.find(_.get(tncType, 'transactionSubTypes', []), { transaction_SubType: role });
    const [tncCount, setTnCCount] = useState(-1);

    useEffect(() => {
        if (isAuthorisedUser) {
            history.push('/');
        }
    }, [history, isAuthorisedUser]);

    useEffect(() => {
        if (!isAuthorisedUser && !_.isEmpty(tncType)) {
            const request = {
                email_Address: EmailUtil.checkEmailValidity(email) ? email : userName,
                acceptance: 1,
                Transaction_Type: _.get(tncType, 'id'),
                Transaction_SubTypes: [
                    _.get(tncSubType, 'id')
                ]
            };

            PolicyService.getAcceptedTnCCount(request, authHeader)
                .then((count) => {
                    if (count === 1) {
                        return setTnCCount(count);
                    }
                    if (count < 1) {
                        return history.push('/terms-and-conditions');
                    }
                    return history.push('/');
                })
                .catch((err) => {
                    error(`UserEmailConfirmation: useEffect - Unable to get TnC Count ${JSON.stringify(err)}`);
                    ModalNextProvider.showAlert({
                        title: messages.userEmailLoadErrorTitle,
                        message: messages.userEmailLoadErrorTitle,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: messages.ok
                    }).then(() => {
                        return history.push('/');
                    }, _.noop);
                });
        }
    }, [authHeader, email, history, isAuthorisedUser, tncSubType, tncType, userName]);


    const onValueChange = useCallback(
        (value, path) => {
            const formDataClone = _.cloneDeep(formData);
            _.set(formDataClone, path, value);
            setFormData(formDataClone);
        },
        [formData]
    );

    const onSubmit = useCallback(() => {
        if (!isFormSubmitted && tncCount === 1) {
            setFormSubmitted(true);
            const payload = {
                policyNumber: _.isEmpty(enrolledPolicy) ? null : enrolledPolicy,
                Email: _.get(formData, 'email', '')
            };
            EndorsementService.performProfileChange(payload, authHeader)
                .then((response) => {
                    if (response) {
                        // Mark the history object so that we will know later
                        // that we came from this screen. Currently this is
                        // used in the LandingPage to delay the request for
                        // the user notifications to avoid a race condition.
                        history.fromEmailConf = true;
                        return history.push('/');
                    }
                    setFormSubmitted(false);
                    return null;
                })
                .catch((err) => {
                    error(`UserEmailConfirmation: onSubmit - Unable to submit ${JSON.stringify(err)}`);
                    ModalNextProvider.showAlert({
                        title: messages.userEmailErrorTitle,
                        message: messages.userEmailErrorMessage,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: messages.ok
                    }).then(() => {
                        setFormSubmitted(false);
                        return history.push('/');
                    }, _.noop);
                });
        }
    }, [EndorsementService, authHeader, enrolledPolicy, formData,
        history, isFormSubmitted, tncCount]);

    const getButtonState = useCallback(() => {
        if (!EmailUtil.checkEmailValidity(formData.email)) {
            return true;
        }
        if (!acceptCheckbox) {
            return true;
        }
        return false;
    }, [acceptCheckbox, formData]);

    const isEmailValid = useCallback(() => {
        return EmailUtil.checkEmailValidity(formData.email);
    }, [formData]);

    const resolvers = {
        resolveClassNameMap: styles
    };

    const overrideProps = {
        emailCheckbox: {
            value: acceptCheckbox,
            onValueChange: setAcceptCheckbox,
            label: messages.tncAcceptance
        },
        tcSubmitButton: {
            disabled: getButtonState() && tncCount > 0,
            onClick: onSubmit
        },
        usernameEmail: {
            value: formData.email,
            onValueChange: onValueChange,
            showErrors: !isEmailValid(),
            validationMessages: !isEmailValid() && [
                'Value must be a valid email address'
            ],
        }
    };


    return renderContentFromMetadata(metadata.pageContent, overrideProps, resolvers);
}

export default withRouter(withAuthenticationContext(
    withApplicationPropertyContext(UserEmailConfirmation)
));
